import { forwardRef } from 'react'
import { UseFormFieldProps, useFormField, FormField } from './FormField'
import { TextAreaProps as RootProps } from '@/ui/TextArea'
import { TextArea as Root } from '@/ui/TextArea'

interface Props extends UseFormFieldProps, RootProps {
    // UseFormFieldProps requires 'name', so we override.
    // This also allows us to extend UseFormFieldProps and
    // RootProps at the same time.
    name: string
}

export const TextArea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
    const { formFieldProps, childProps } = useFormField(props)

    return (
        <FormField {...formFieldProps}>
            <Root {...childProps} ref={ref} />
        </FormField>
    )
})
